import { TextField, TextFieldProps } from '@mui/material';
import { ChangeEvent, useState } from 'react';

import { FieldMetaData } from './types';

type TextTFCProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
  onChange: (value: string, fieldMetaData: FieldMetaData) => void;
  initialValue?: string;
};

export default function TextTFC({ onChange, initialValue = '', ...props }: TextTFCProps) {
  const [value, setValue] = useState(initialValue);
  const handleOnChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    onChange(newValue, { state: 'valid', error: null });
  };

  return (
    <TextField value={value} onChange={handleOnChange} type="text" {...props} color="secondary" />
  );
}
